import { render } from "./MergeSegment.vue?vue&type=template&id=5316d4cc&scoped=true&ts=true"
import script from "./MergeSegment.vue?vue&type=script&lang=ts"
export * from "./MergeSegment.vue?vue&type=script&lang=ts"

import "./MergeSegment.vue?vue&type=style&index=0&id=5316d4cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5316d4cc"]])

export default __exports__